/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Cfg_Allow_Proxies_DescInputs */



/**
* | output |
* | --- |
* | "proxy cards in decklists (Standard rank only)" |
*
* @param {Og_Cfg_Allow_Proxies_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_cfg_allow_proxies_desc = /** @type {((inputs?: Og_Cfg_Allow_Proxies_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Cfg_Allow_Proxies_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("cartes proxy dans les listes de deck (rang Standard uniquement)")
	if (locale === "es") return /** @type {LocalizedString} */ ("cartas proxy en las listas de mazo (solo rango Standard)")
	if (locale === "pt") return /** @type {LocalizedString} */ ("cartas proxy nas listas de deck (apenas rank Standard)")
	if (locale === "it") return /** @type {LocalizedString} */ ("carte proxy nelle liste dei mazzo (solo rank Standard)")
	return /** @type {LocalizedString} */ ("proxy cards in decklists (Standard rank only)")
});